import {
  CameraControls,
  ContactShadows,
  Environment,
  Text,
} from "@react-three/drei";
import { Suspense, useEffect, useRef, useState } from "react";
import { useChat } from "../hooks/useChat";
import { Avatar } from "./Avatar";
import { useSelector } from "react-redux";

const Dots = (props: any) => {
  const { loading } = useSelector((state: any) => state.candidateInterviewBot)

  const [loadingText, setLoadingText] = useState("");
  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setLoadingText((loadingText) => {
          if (loadingText.length > 2) {
            return ".";
          }
          return loadingText + ".";
        });
      }, 800);
      return () => clearInterval(interval);
    } else {
      setLoadingText("");
    }
  }, [loading]);

  if (!loading) return null;

  return (
    <group {...props}>
      <Text fontSize={0.14} anchorX={"left"} anchorY={"bottom"}>
        {loadingText}
        <meshBasicMaterial attach="material" color="black" />
      </Text>
    </group>
  );
};

export const Experience = ({interviewerAvatar}: {interviewerAvatar: string}) => {
  const cameraControls = useRef<any>();
  // const { cameraZoomed } = useChat();

  useEffect(() => {
    cameraControls.current.setLookAt(0, 2, 5, 0, 1.5, 0);
  }, []);

  // useEffect(() => {
  //   // if (cameraZoomed) {
  //   //   cameraControls.current.setLookAt(0, 1.5, 1.5, 0, 1.5, 0, true);
  //   // } else {
  //   //   cameraControls.current.setLookAt(0, 2.2, 5, 0, 1.0, 0, true);
  //   // }
  // }, [cameraZoomed]);
  
  return (
    <>
      <CameraControls ref={cameraControls} />
      <Environment preset="sunset" />
      {/* Wrapping Dots into Suspense to prevent Blink when Troika/Font is loaded */}
      <Avatar
        interviewerAvatar={interviewerAvatar} />
      <ContactShadows opacity={0.7} />
    </>
  );
};
